{
  "title": "Sozlamalar",
  "landing": {
    "interface": "Interfeys sozlamalari",
    "interfaceDesc": "Til, mavzu va rang",
    "hotkeys": "Tezkor tugmalar",
    "hotkeysDesc": "Klaviatura qisqartmalari"
  },
  "actions": {
    "reset": "Standartga qaytarish",
    "cancel": "Bekor qilish",
    "save": "Saqlash"
  },
  "saved": "Saqlandi",
  "error": "Xatolik yuz berdi",
  "resetTitle": "Standart sozlamalarga qaytarilsinmi?",
  "resetText": "Til, mavzu, asosiy rang va ko'rinish standart qiymatlarga qaytadi. Saqlash uchun «Saqlash» tugmasini bosing.",
  "resetConfirm": "Qaytarish",
  "unsavedTitle": "O'zgarishlar saqlanmagan",
  "unsavedText": "Saqlanmagan o'zgarishlar bekor qilinadi.",
  "stay": "Qolish",
  "leave": "Chiqish",
  "interface": {
    "title": "Interfeys sozlamalari",
    "language": "Til",
    "languageDesc": "Interfeys matnlari va sana formati tanlangan tilda ko'rsatiladi",
    "languages": {
      "uz-Latn": { "name": "O'zbekcha", "sub": "Lotin yozuvi" },
      "uz-Cyrl": { "name": "Ўзбекча", "sub": "Кирилл ёзуви" },
      "ru": { "name": "Русский", "sub": "Русский язык" },
      "en": { "name": "English", "sub": "English" }
    },
    "theme": "Mavzu",
    "themeDesc": "Yorug' yoki qorong'i rejim. «Tizim» qurilma sozlamasiga ergashadi",
    "themes": {
      "light": "Yorug'",
      "dark": "Qorong'i",
      "system": "Tizim"
    },
    "accent": "Asosiy rang",
    "accentDesc": "Tugmalar, faol tab va havolalarga qo'llanadi",
    "customHex": "Maxsus rang (HEX)",
    "custom": "Maxsus rang",
    "accents": {
      "blue": "Ko'k",
      "green": "Yashil",
      "darkGreen": "To'q yashil",
      "yellow": "Sariq",
      "orange": "To'q sariq",
      "red": "Qizil",
      "pink": "Pushti",
      "purple": "Binafsha"
    },
    "view": "Ko'rinish",
    "compact": "Ixcham jadval",
    "compactDesc": "Qatorlar balandligi kamayadi, ko'proq ma'lumot sig'adi",
    "animations": "Animatsiyalar",
    "animationsDesc": "Panel va modallar ochilishida yumshoq o'tish",
    "fontSize": "Matn o'lchami",
    "fontSizes": {
      "12": "Juda kichik (12 px)",
      "13": "Kichik (13 px)",
      "14": "O'rtacha (14 px)",
      "15": "Katta (15 px)",
      "16": "Juda katta (16 px)"
    },
    "preview": "Namuna",
    "previewDesc": "Tanlangan mavzu va rang qanday ko'rinishini oldindan ko'ring",
    "sample": {
      "title": "Barcha xodimlar",
      "add": "Qo'shish",
      "in": "Kiradi",
      "out": "Kirmaydi",
      "viewOnly": "Faqat ko'rish",
      "save": "Saqlash",
      "cancel": "Bekor qilish",
      "active": "Faol xodim"
    }
  },
  "hotkeys": {
    "title": "Tezkor tugmalar",
    "search": "Amal nomi yoki tugma bo'yicha izlash",
    "conflicts": "{{count}} ta takrorlanish",
    "columns": {
      "action": "Amal",
      "description": "Tavsif",
      "combo": "Tezkor tugma",
      "status": "Holat",
      "actions": "Harakat"
    },
    "groups": {
      "general": "Umumiy",
      "drawing": "Chizma",
      "table": "Jadval"
    },
    "status": {
      "default": "Standart",
      "error": "Xato",
      "modified": "O'zgartirilgan",
      "conflict": "Takrorlanadi",
      "editing": "Tahrirlanmoqda"
    },
    "capture": "Tugmalarni bosing...",
    "captureLabel": "Yangi tezkor tugma: {{name}}",
    "edit": "Tahrirlash",
    "accept": "Qabul qilish",
    "cancelEdit": "Bekor qilish",
    "resetRow": "Standartga qaytarish",
    "none": "Belgilanmagan",
    "reserved": "Bu brauzer tugmasini band qilib bo'lmaydi",
    "busy": "Tugma band: {{name}}",
    "saved": "Tezkor tugma saqlandi",
    "conflictToast": "Bu tugma «{{name}}» amali bilan takrorlanadi",
    "resetAllTitle": "Barcha tezkor tugmalar standartga qaytarilsinmi?",
    "resetAllText": "Siz o'zgartirgan barcha tezkor tugmalar standart qiymatga qaytadi.",
    "resetConfirm": "Qaytarish",
    "empty": "Hech narsa topilmadi",
    "emptyHint": "Qidiruv so'zini o'zgartirib ko'ring.",
    "toggleGroup": "{{name}} guruhini ochish/yopish",
    "actions": {
      "create": { "label": "Yaratish", "description": "Yangi element qo'shish" },
      "save": { "label": "Saqlash", "description": "O'zgarishlarni saqlash" },
      "search": { "label": "Qidirish", "description": "Global qidiruvni ochish" },
      "cancel": { "label": "Bekor qilish", "description": "Oynani yoki amalni yopish" },
      "refresh": { "label": "Yangilash", "description": "Ma'lumotlarni qayta yuklash" },
      "help": { "label": "Yordam", "description": "Foydalanish qo'llanmasini ochish" },
      "zoomIn": { "label": "Kattalashtirish", "description": "Chizmani yaqinlashtirish" },
      "zoomOut": { "label": "Kichraytirish", "description": "Chizmani uzoqlashtirish" },
      "addDevice": { "label": "Qurilma qo'shish", "description": "Chizmaga yangi qurilma joylash" },
      "layers": { "label": "Qatlamlar", "description": "Qatlamlar menyusini ko'rsatish" },
      "export": { "label": "Eksport qilish", "description": "Jadvalni Excel fayliga yuklash" },
      "copy": { "label": "Nusxalash", "description": "Tanlangan qatorlarni nusxalash" },
      "selectAll": { "label": "Barchasini tanlash", "description": "Barcha qatorlarni belgilash" },
      "saveChart": { "label": "Grafikni saqlash", "description": "Joriy grafikni tabga saqlash" }
    }
  }
}
